<script setup lang="ts">
import { formatPrice } from "@/utils/Formatting";
import { useRouter, useRoute } from "vue-router";

const router = useRouter()
const route = useRoute()
interface Props {
  isAddCardDialogVisible: boolean;
  addCardDialogMessage: any;
  totalAmount?: number;
  surchargeAmount?: number;
  cardIsProcessing? :boolean
}

interface Emits {
  (e: "closeDialog", value: boolean): void;
  (e: "emailReceipt"): void;
  (e: "printReceipt"): void;
}

// Props
const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const refreshPage = () => {
  if(props.addCardDialogMessage?.status === 'Approved') {
    try {
      router.push(route.path)
    } catch (e) {
    }
  }
}

</script>

<template>
  <div>
    <VDialog
      :model-value="props.isAddCardDialogVisible"
      persistent
      max-width="600"
      max-height="800"
      no-click-animation
      @update:model-value="emit('closeDialog', false)"
    >
      <VCard>
        <div
          class="d-flex align-center justify-space-between bg-dialogHeaderColor"
        >
          <VCardTitle> Card Payment </VCardTitle>

          <VBtn
            icon="mdi-close"
            size="large"
            variant="text"
            class="rounded-0"
            color=""
            @click="refreshPage();emit('closeDialog', false)"
          />
        </div>

        <VCardText class="text-center">
          <VProgressCircular
            v-if="props?.cardIsProcessing || (
              props.addCardDialogMessage?.spinner &&
              props.addCardDialogMessage?.isVisible)
            "
            :color="props.addCardDialogMessage?.color"
            indeterminate
            :size="50"
            variant="outlined"
          />
          <div class="text-center my-4">
            <span class="text-h5">
              Payment of {{ formatPrice(props.totalAmount) }} with Card
            </span>
            <span v-if="props.surchargeAmount" class="surcharge-info">
              ( including surcharge of {{ formatPrice(props.surchargeAmount) }}
              )
            </span>
          </div>
          <p v-if="!props?.cardIsProcessing"
            class="text-h4 my-5"
            :class="`text-${props.addCardDialogMessage?.color}`"
          >
            {{ props.addCardDialogMessage?.message }}
          </p>
        </VCardText>

        <VCardActions v-if="!props?.cardIsProcessing">
          <div v-if="props.addCardDialogMessage?.status === 'Approved'">
            <VBtn
              color="primary"
              variant="flat"
              class="rounded-sm"
              @click="emit('emailReceipt')"
            >
              Email Receipt
            </VBtn>
            <VBtn
              color="primary"
              variant="flat"
              class="rounded-sm"
              @click="emit('printReceipt')"
            >
              Print Receipt
            </VBtn>
          </div>
          <VSpacer />
          <VBtn
            color="error"
            variant="flat"
            class="rounded-sm"
            @click="refreshPage(); emit('closeDialog', false)"
          >
            Close
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </div>
</template>
